import styled from "@emotion/styled"
import { Desktop, Mobile, NewText } from "ui"

import { PieChart } from "./PieChart"
import ShareHolderTable from "./ShareHolderTable"

const StyledPieChartWrapper = styled.div`
  height: 328px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 400px;
    width: 100%;
    margin-bottom: 0;
  }
  canvas {
    object-fit: cover;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  .chartjs-tooltip {
    height: auto !important;
  }
`

const StyledBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${(props) => props.theme.breakpoints.up("md")} {
    align-items: center;
    margin: 0 auto;
  }
`
const StyledWrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    display: flex;
    justify-content: center;
    padding-top: 60px;
    padding-bottom: 60px;
    align-items: center;
  }
`

const StyledDiv = styled.div``

const StyledTableDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: column;
    row-gap: 8px;
    align-items: center;
    width: 100%;
  }
`

type Props = {
  stockHolderData: any
  dateText: string
}

function ShareHolderSwiper({ stockHolderData, dateText }: Props) {
  return (
    <StyledDiv>
      <StyledWrapper>
        <StyledPieChartWrapper>
          <PieChart stockHolderData={stockHolderData} />
        </StyledPieChartWrapper>

        <StyledTableDiv>
          <ShareHolderTable stockHolderData={stockHolderData} />
          <Desktop>
            <StyledBottomContainer>
              <NewText
                component={"p"}
                desktopFontSize={14}
                desktopLineHeight={"20.16px"}
                color="black"
              >
                {dateText}
              </NewText>
            </StyledBottomContainer>
          </Desktop>
        </StyledTableDiv>
      </StyledWrapper>
      <Mobile>
        <StyledBottomContainer>
          <NewText
            component={"p"}
            desktopFontSize={14}
            desktopLineHeight={"20px"}
            mobileFontSize={14}
            mobileLineHeight={"20.16px"}
            color="black"
          >
            {/* *{asOf} 30.06.2023 */}
            {dateText}
          </NewText>
        </StyledBottomContainer>
      </Mobile>
    </StyledDiv>
  )
}

export default ShareHolderSwiper
